import "./Button.css";

interface Props {
  children: React.ReactNode;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}

export const Button = ({ children, type = "button", disabled = false, onClick, className = "" }: Props) => {
  return (
    <button type={type} disabled={disabled} onClick={onClick} className={`looksty-button ${className}`}>
      {children}
    </button>
  );
};
